import { render, staticRenderFns } from "./TarimaDevolucionFormComponent.vue?vue&type=template&id=0db72ef8&"
import script from "./TarimaDevolucionFormComponent.vue?vue&type=script&lang=js&"
export * from "./TarimaDevolucionFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports